import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ZigzagIcon = props => (
  <Icon viewBox="0 0 24 24" w="full" h="full" color="inherit" {...props}>
    <path d="M21.71,16.29l-2-2a1,1,0,0,0-1.42,1.42l.3.29H6a2,2,0,0,1,0-4h9a4,4,0,0,0,0-8H3A1,1,0,0,0,3,6H15a2,2,0,0,1,0,4H6a4,4,0,0,0,0,8H18.59l-.3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l2-2A1,1,0,0,0,21.71,16.29Z" />
  </Icon>
);
